import React, { useContext, useEffect } from 'react';
import { StyledTrialAccessBanner, StyledTrialAccessContent, StyledTrialAccessMessage } from '../Styled';
import AuthContext from '../../contexts/authContext';

export const TrialAccessBanner: React.FC = () => {
  const { trialDaysLeft, setTrialDaysLeft } = useContext(AuthContext);

  const listenTrialDaysLeftUpdate = (event: Event) => {
    setTrialDaysLeft((event as CustomEvent).detail.trialDaysLeft);
  };

  useEffect(() => {
    window.addEventListener('trialDaysLeftUpdated', listenTrialDaysLeftUpdate);

    return () => {
      window.removeEventListener('trialDaysLeftUpdated', listenTrialDaysLeftUpdate);
    };
  }, []);

  const expireMessage = trialDaysLeft > 1 ? `in ${trialDaysLeft} days` : 'today';

  return (
    <StyledTrialAccessBanner testId="trial-access-banner">
      <StyledTrialAccessContent>
        This is a preview account.{' '}
        <StyledTrialAccessMessage data-testid="trial-access-banner-message">
          It will expire {expireMessage}.
        </StyledTrialAccessMessage>
      </StyledTrialAccessContent>
    </StyledTrialAccessBanner>
  );
};
